import { render, staticRenderFns } from "./ShopCardex.vue?vue&type=template&id=02f05d32&"
import script from "./ShopCardex.vue?vue&type=script&lang=js&"
export * from "./ShopCardex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports